module.exports = __webpack_public_path__ + "img/qr-code.a70e21d3.png";